export default {
  // Estado del loader
  // Inicialmente mostramos el loader
  // luego de que carga la primera vista
  // lo quitamos
  isLoading: true,
  // Adobe App Started
  trackClickElement: null,
  // Model del paso 1
  paso1: {
    nombre: "",
    apellido: "",
    email: "",
    celular: {
      area: "",
      numero: ""
    },
    documento: {
      tipo: "",
      numero: ""
    },
    tarjeta: ""
  }
};
